<template>
    <dashboard-layout>
        <div>
            <h2>Category Performance Compared to Peers</h2>
            <p>
                This chart shows your performance compared to your peers in each category. The <b style="color: rgba(75, 192, 192, 1)">green</b> bars represent your
                score, while the yellow bars represent the average score of all users in the category.
            </p>
            <p v-if="loading">Loading...</p>
            <div v-else>
                <CategoryBarChart :chart-data="chartData" :options="chartOptions"></CategoryBarChart>
            </div>
        </div>
    </dashboard-layout>
</template>

<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';
import { defineComponent, ref } from 'vue';
import { useRoute } from "vue-router";
import DashboardLayout from "../../dashboard-layout.vue";
import CategoryBarChart from "./CategoryBarChart.vue";

const toast = useToast();

export default defineComponent({
    components: {
        CategoryBarChart,
        DashboardLayout,
    },
    setup() {
        const categoryPerformance = ref([]);
        const loading = ref(true);
        const route = useRoute();

        const chartData = ref({
            labels: [],
            datasets: [
                {
                    label: 'Your Score',
                    backgroundColor: 'rgba(75, 192, 192, 0.7)',
                    borderColor: 'rgba(75, 192, 192, 1)',
                    borderWidth: 1,
                    data: []
                },
                {
                    label: 'Average User Score',
                    backgroundColor: 'rgba(255, 205, 86, 0.7)',
                    borderColor: 'rgba(255, 205, 86, 1)',
                    borderWidth: 1,
                    data: []
                }
            ]
        });

        const chartOptions = ref({
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: {
                    stacked: true
                },
                y: {
                    beginAtZero: true
                }
            }
        });

        const fetchData = () => {
            const id = toast.info('Getting content ...', { icon: 'fa-solid fa-download' });
            axios.get('/performance/category', {
                params: {
                    'session_id': route.params.subscribe_id,
                    'subscribe_id': route.params.subscribe_id
                }
            })
                .then(response => {
                    categoryPerformance.value = response.data;

                    const categories = categoryPerformance.value.map(item => item.category);
                    const userScores = categoryPerformance.value.map(item => item.user_score);
                    const overallScores = categoryPerformance.value.map(item => item.overall_score);

                    chartData.value.labels = categories;
                    chartData.value.datasets[0].data = userScores;
                    chartData.value.datasets[1].data = overallScores;

                    loading.value = false;
                    toast.dismiss(id);
                })
                .catch(error => {
                    toast.dismiss(id);
                    toast.error(`Error: ${error.response ? error.response.data.message : 'An error occurred'}`);
                });
        };

        return {
            categoryPerformance,
            loading,
            chartData,
            chartOptions,
            fetchData
        };
    },
    mounted() {
        this.fetchData();
    }
});
</script>

<style scoped>
#userScoresChart {
    max-width: 600px;
    margin: auto;
}
</style>
